import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getAgreementEsignStatus = createAsyncThunk(
  "esign/getAgreementEsignStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ type: "business" });
      if (payload?.transactionId) params.append("transactionId", payload.transactionId);
      if (payload?.dealId) params.append("dealId", payload.dealId);
      const response = await axios.get(
        `/api/business/getAgreementEsignStatus?${params.toString()}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getPendingSlaInvitation = createAsyncThunk(
  "esign/getPendingSlaInvitation",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/business/getPendingSlaInvitation");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSlaSignStatus = createAsyncThunk(
  "esign/getSlaSignStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getSlaEsignStatus?document_id=${payload.document_id}&docket_id=${payload.docket_id}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getPendingNdaInvitation = createAsyncThunk(
  "esign/getPendingNdaInvitation",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/business/getPendingNdaInvitation");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getNdaSignStatus = createAsyncThunk(
  "esign/getNdaSignStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getNdaEsignStatus?document_id=${payload.document_id}&docket_id=${payload.docket_id}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const EsignSlice = createSlice({
  name: "esign",
  initialState: {
    esignData: {},
    agreementData: {},
    agreementLoading: false,
    agreementSubmitLoading: false,
    agreementSubmitError: null,
    loading: false,
    error: null,
    pendingSla: null,
    pendingSlaLoading: false,
    pendingSlaError: null,
    pendingNda: null,
    pendingNdaLoading: false,
    pendingNdaError: null,
    checkStatusLoading: false,
    checkStatusError: null,
  },

  reducers: {
    clearPendingSla(state) {
      state.pendingSla = null;
      state.pendingSlaError = null;
    },
    clearPendingNda(state) {
      state.pendingNda = null;
      state.pendingNdaError = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getAgreementEsignStatus.pending, (state) => {
      state.agreementSubmitLoading = true;
      state.agreementSubmitError = null;
    });
    builder.addCase(getAgreementEsignStatus.fulfilled, (state) => {
      state.agreementSubmitLoading = false;
      state.agreementSubmitError = null;
    });
    builder.addCase(getAgreementEsignStatus.rejected, (state, action) => {
      state.agreementSubmitLoading = false;
      state.agreementSubmitError = action.payload;
    });

    builder.addCase(getPendingSlaInvitation.pending, (state) => {
      state.pendingSlaLoading = true;
      state.pendingSlaError = null;
    });
    builder.addCase(getPendingSlaInvitation.fulfilled, (state, action) => {
      state.pendingSlaLoading = false;
      state.pendingSla = action.payload;
      state.pendingSlaError = null;
    });
    builder.addCase(getPendingSlaInvitation.rejected, (state, action) => {
      state.pendingSlaLoading = false;
      state.pendingSlaError = action.payload;
      state.pendingSla = null;
    });

    builder.addCase(getSlaSignStatus.pending, (state) => {
      state.checkStatusLoading = true;
      state.checkStatusError = null;
    });
    builder.addCase(getSlaSignStatus.fulfilled, (state) => {
      state.checkStatusLoading = false;
      state.checkStatusError = null;
    });
    builder.addCase(getSlaSignStatus.rejected, (state, action) => {
      state.checkStatusLoading = false;
      state.checkStatusError = action.payload;
    });

    builder.addCase(getPendingNdaInvitation.pending, (state) => {
      state.pendingNdaLoading = true;
      state.pendingNdaError = null;
    });
    builder.addCase(getPendingNdaInvitation.fulfilled, (state, action) => {
      state.pendingNdaLoading = false;
      state.pendingNda = action.payload;
      state.pendingNdaError = null;
    });
    builder.addCase(getPendingNdaInvitation.rejected, (state, action) => {
      state.pendingNdaLoading = false;
      state.pendingNdaError = action.payload;
      state.pendingNda = null;
    });

    builder.addCase(getNdaSignStatus.pending, (state) => {
      state.checkStatusLoading = true;
      state.checkStatusError = null;
    });
    builder.addCase(getNdaSignStatus.fulfilled, (state) => {
      state.checkStatusLoading = false;
      state.checkStatusError = null;
    });
    builder.addCase(getNdaSignStatus.rejected, (state, action) => {
      state.checkStatusLoading = false;
      state.checkStatusError = action.payload;
    });
  },
});

export const { clearPendingSla, clearPendingNda } = EsignSlice.actions;

export default EsignSlice.reducer;
